import React, { useMemo } from 'react';
import { type MRT_ColumnDef } from 'material-react-table';
import * as Const from '../../utils/Const';
import { GetSummaryRuleOptionName } from '../../utils/UtilFunction';

export type SummaryTableList = {
  summary_item: string;
  material_name: string;
  scene_name: string;
  start_datetime_utc: Date;
  end_datetime_utc: Date;
  user_name: string;
  experiencer_name: number;
  device_id: string;
};

export const GetColumns = (summaryItemId: number) => {
  return useMemo<MRT_ColumnDef<SummaryTableList>[]>(
    () => [
      {
        accessorKey: `${Const.KeySummaryItem}`,
        header: `${GetSummaryRuleOptionName(summaryItemId)}`,
        enableEditing: false,
        grow: false,
        size: 200,
      },
      {
        accessorKey: `${Const.KeyMaterialName}`,
        header: `${Const.LabelListMaterialName}`,
        enableEditing: false,
        grow: false,
        size: 200,
      },
      {
        accessorKey: `${Const.KeySceneName}`,
        header: `${Const.LabelListSceneName}`,
        enableEditing: false,
        grow: false,
        size: 200,
      },
      {
        accessorKey: `${Const.KeyStartDatetimeUtc}`,
        header: `${Const.LabelListStartDatetimeUtc}`,
        enableEditing: false,
        grow: false,
        size: 510,
        filterVariant: 'datetime-range',
        accessorFn: (originalRow) => new Date(originalRow.start_datetime_utc),
        Cell: ({ cell }) => {
          const temp = cell.getValue<string>();
          const date = new Date(temp).toLocaleDateString();
          const time = new Date(temp).toLocaleTimeString();
          return `${date} ${time}`;
        },
      },
      {
        accessorKey: `${Const.KeyEndDatetimeUtc}`,
        header: `${Const.LabelListEndDatetimeUtc}`,
        enableEditing: false,
        grow: false,
        size: 510,
        filterVariant: 'datetime-range',
        accessorFn: (originalRow) => new Date(originalRow.end_datetime_utc),
        Cell: ({ cell }) => {
          const temp = cell.getValue<string>();
          const date = new Date(temp).toLocaleDateString();
          const time = new Date(temp).toLocaleTimeString();
          return `${date} ${time}`;
        },
      },
      {
        accessorKey: `${Const.KeyUserName}`,
        header: `${Const.LabelListUserName}`,
        enableEditing: false,
        grow: false,
        size: 200,
      },
      {
        accessorKey: `${Const.KeyExperiencerName}`,
        header: `${Const.LabelListExperiencerName}`,
        enableEditing: false,
        grow: false,
        size: 200,
      },
      {
        accessorKey: `${Const.KeyDeviceId}`,
        header: `${Const.LabelListDeviceId}`,
        enableEditing: false,
        grow: false,
        size: 200,
      },
    ],
    []
  );
};
